<template>
  <component :is="strong ? 'strong' : 'span'">
    <span class="ltr">
      ×<slot />
    </span>
  </component>
</template>

<script setup lang="ts">
defineProps<{
  strong?: boolean;
}>();
</script>

<style scoped>
span, strong {
  unicode-bidi: bidi-override;
}
</style>